<template>
  <!-- 筛选-->
  <FilterHeader ref="filterHeader"
                :total="total"
                :facet-list="facetList"
                :showFilterParams="showFilterParams"
                @deleteFilterParams="deleteFilterParams"
                @getFilterParams="getFilterParams"/>
  <van-loading size="24px" vertical v-if="loading">加载中...</van-loading>
  <!--推荐图书-->
  <BookBlock :list="recommend" @onLoad="onLoad" ref="bookChild" v-else/>
</template>

<script>
import {defineComponent, ref, onMounted} from 'vue';
import BookBlock from './BookBlock';
import {FilterHeader, FilterPopup} from '../components/common';
import {getRecommend} from '@/api/books';
import {isNotEmpty, setCovers} from '@/utils/util';

export default defineComponent({
  name: 'Recommend',
  components: {
    BookBlock,
    FilterPopup,
		FilterHeader
  },
  setup() {
    const recommend = ref([]);
    const loading = ref(true);
    const total = ref(0);
    let page = 1;
    const bookChild = ref();
		// 过滤值
    const filterHeader = ref();
		const facetList = ref([]);
		const showFilterParams = ref([]);
		let filterParams = null;

    // 新书速递
    const onRecommend = () => {
      let params = filterParams ? new URLSearchParams(filterParams) : new URLSearchParams();
      params.append('page', page);
      params.append('pageSize', '20');
      getRecommend(params)
          .then(data => {
            if (data) {
              total.value = data.total;
              if (isNotEmpty(data.dataList)) {
                const isbns = [];
                data.dataList.forEach(item => {
                  if (isNotEmpty(item.isbn)) {
                    isbns.push(item.isbn);
                  }
                });
                if(isNotEmpty(isbns)){
									setCovers(isbns, data.dataList);
								}
                recommend.value = recommend.value.concat(data.dataList);
              }
              page++;
              facetList.value = data.facetList ?? [];
            }
            if (isNotEmpty(bookChild.value)) {
              bookChild.value.loading = false; // 加载状态结束
              bookChild.value.finished = recommend.value.length >= total.value;
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => loading.value = false);
    };
    const onLoad = () => {
      if (recommend.value.length < total.value) {
        onRecommend();
      } else {
        bookChild.value.loading = false; // 加载状态结束
        bookChild.value.finished = recommend.value.length >= total.value;
      }
    };
    // 处理过滤条件
    const getFilterParams = (params,showParams) => {
      filterParams = params;
      showFilterParams.value = showParams;
      page =1;
      recommend.value =[];
      onRecommend();
    }
    // 删除过滤条件
    const deleteFilterParams = (key)=>{
      showFilterParams.value = showFilterParams.value.filter(item => item.code !==key);
      if(key ==='yearStartEnd'){
        filterParams.delete('startPublicationYear');
        filterParams.delete('endPublicationYear');
      }
      else{
        filterParams.delete(key);
      }
      if (showFilterParams.value.length === 0) {
        filterHeader.value?.resetPop(); // 清空筛选条件的选择
      }
      page =1;
      recommend.value =[];
      onRecommend();
    }
    onMounted(() => {
      onRecommend();
    });
    return {
      recommend,
      total,
      bookChild,
      onLoad,
      loading,
			facetList,
			showFilterParams,
			getFilterParams,
			deleteFilterParams,
      filterHeader
    }
  }
});
</script>

<style scoped lang="less">
</style>
